import { Avatar, Box, Typography } from '@mui/material'
import CustomText from 'components/common/CustomText/CustomText'
import React from 'react'
import { IPhotoSize } from 'types/types'

interface Props {
  images: IPhotoSize[]
  size?: number
  setCarouselImages: (images: IPhotoSize[]) => void
  setInitialIndex: (index: number) => void
  setCarouselOpen: (value: boolean) => void
  maxVisible?: number;
}

export default function SmallImagesList({
  images,
  size = 30,
  setCarouselImages,
  setInitialIndex,
  setCarouselOpen,
  maxVisible = 3,
}: Props) {
  const hasExtraImages = images.length > maxVisible
  const visibleImages = hasExtraImages
    ? images.slice(0, maxVisible + 1)
    : images

  const handleClick = (index: number) => {
    setCarouselImages(images)
    setInitialIndex(index)
    setCarouselOpen(true)
  }

  return (
    <Box display="flex" flexDirection="row">
      {visibleImages.map((item, index) => {
        const isOverlay = hasExtraImages && index === maxVisible
        const remainingCount = images.length - maxVisible

        return (
          <Box
            key={index}
            margin={0.5}
            sx={{
              position: 'relative',
              width: size,
              height: size,
              cursor: 'pointer',
            }}
            onClick={(e) => {
              e.stopPropagation()
              handleClick(index)
            }}
          >
            <Avatar
              src={item.small || ''}
              variant="rounded"
              sx={{
                width: size,
                height: size,
                filter: isOverlay ? 'brightness(0.6)' : 'none',
              }}
            />

            {isOverlay && (
              <Box
                sx={{
                  position: 'absolute',
                  inset: 0,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  bgcolor: 'rgba(0,0,0,0.2)',
                  borderRadius: 1,
                }}
              >
                <CustomText
                  text={`+${remainingCount}`}
                  color='white'
                  fontSize={14}
                />
              </Box>
            )}
          </Box>
        )
      })}
    </Box>
  )
}
